<template>
  <div class="service-no-moist-alarm">
    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <moisture-component
      v-if="computedAlarmIsActive"
      class="g-alarm-handler__row"
      :moisture="computedMoist"
      :store="store"
    />

    <!-- <div class="g-alarm-handler__row">
      <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>{{ $t('messages.alarms.serviceMoistAlarm.suggestion') }}</p>
    </div> -->

    <!-- <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
    /> -->
  </div>
</template>


<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'
import MoistureComponent from '@/components/MoistureComponent'

export default {
  name: 'ServiceMoistAlarm',
  components: {
    'moisture-component': MoistureComponent
  },
  mixins: [ServiceAlarm],
  computed: {
    computedMoist() {
      const sensors = Object.assign({}, this.store.getData('moisture'))

      sensors.list = sensors && sensors.list.length ? sensors.list.filter(item => item.state !== 4) : []
      return sensors
    }
  }
}
</script>
